import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var ZoomControls = createComponent({
  displayName: 'ZoomControls',
  root: 'div',
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.zoomControls,
  propConfig: {
    classNames: ['swan-zoom-controls']
  }
});
export { ZoomControls };